// ======================================================================
// File Name       : video
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function getUploadSignatureRequest(params) {
  return commonCallApi({
    path: 'video/GetUploadSignature',
    data: params,
  });
}

export function editVideo(params) {
  return commonCallApi({
    path: 'video/Edit',
    data: params,
  });
}
// Get video list
export function getVideos(params) {
  return commonCallApi({
    path: 'video/GetList',
    data: params,
  });
}
// Get player
export function getPlayer(params) {
  return commonCallApi({
    path: 'video/GetVideo',
    data: params,
  });
}
